/* Lavender Farm Simulator — Phase 3: juice, weekly farm report, season cards, sound.
   1. Instant feedback on every field action: a water splash with darkening soil, a sprout pop when planting,
      a lavender bundle and coin count when harvesting, an inspect ping, a dust puff when clearing, and a
      "+coins" float whenever money comes in. Blooming plots get a bee; early mornings get a light mist.
   2. Weekly farm report after "Advance week": a season card when the season turns, a greeting from
      Huckleberry, what the weather did, how the plants changed, money in and out, one surprise, and one
      decision for next week, with a big "Next week →" button. Can be turned off from the report.
   3. Farm sounds (off by default): wind, birds by day, crickets on summer nights, bees in bloom season,
      plus small splash/pop/coin sounds. Made in the browser, no sound files to download.
   Reads the save and presses the game's own buttons; never writes the save. Honors reduced motion. */
(function () {
  'use strict';
  if (window.__gllfSimJuice) return;
  window.__gllfSimJuice = true;

  var BASE = ((document.currentScript && document.currentScript.src) || '').replace(/gllf-sim-juice\.js.*$/, '');
  if (BASE && !document.querySelector('link[href*="gllf-sim-juice.css"]')) {
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = BASE + 'gllf-sim-juice.css'; document.head.appendChild(l);
  }
  function art(id) { return BASE + 'gllf-art-' + id + '.webp'; }
  function root() { return document.getElementById('lfg-simulator-root'); }
  function st() { var r = root(); try { return r && r._lfg ? r._lfg.state() : null; } catch (e) { return null; } }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function reduced() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function clone(x) { try { return JSON.parse(JSON.stringify(x)); } catch (e) { return null; } }
  function money(n) { n = Math.round(+n || 0); return (n < 0 ? '−' : '') + Math.abs(n).toLocaleString('en-US'); }
  function place(s) { return String((s && s.place) || 'your farm').split(',')[0]; }

  /* ================= sound ================= */
  var AC = null, master = null, amb = null, soundOn = ls('gllfSoundV1') === '1';
  function ctx() {
    if (AC) return AC;
    var C = window.AudioContext || window.webkitAudioContext; if (!C) return null;
    AC = new C(); master = AC.createGain(); master.gain.value = 0.22; master.connect(AC.destination);
    return AC;
  }
  function noiseBuf(sec, brown) {
    var b = AC.createBuffer(1, AC.sampleRate * sec, AC.sampleRate), d = b.getChannelData(0), last = 0;
    for (var i = 0; i < d.length; i++) { var w = Math.random() * 2 - 1; if (brown) { last = (last + 0.02 * w) / 1.02; d[i] = last * 3.5; } else d[i] = w; }
    return b;
  }
  function env(g, t, a, peak, dur) { g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(peak, t + a); g.gain.exponentialRampToValueAtTime(0.0001, t + dur); }
  function blip(freq, dur, type, vol, glide) {
    if (!soundOn || !ctx()) return; var t = AC.currentTime, o = AC.createOscillator(), g = AC.createGain();
    o.type = type || 'sine'; o.frequency.setValueAtTime(freq, t); if (glide) o.frequency.exponentialRampToValueAtTime(glide, t + dur);
    env(g, t, 0.01, vol || 0.3, dur); o.connect(g); g.connect(master); o.start(t); o.stop(t + dur + 0.05);
  }
  function hiss(dur, f, q, vol) {
    if (!soundOn || !ctx()) return; var t = AC.currentTime, n = AC.createBufferSource(), bp = AC.createBiquadFilter(), g = AC.createGain();
    n.buffer = noiseBuf(dur + 0.1); bp.type = 'bandpass'; bp.frequency.value = f; bp.Q.value = q || 1;
    env(g, t, 0.02, vol || 0.4, dur); n.connect(bp); bp.connect(g); g.connect(master); n.start(t); n.stop(t + dur + 0.1);
  }
  var SFX = {
    water: function () { hiss(0.6, 1800, 0.8, 0.35); setTimeout(function () { hiss(0.35, 3200, 2, 0.15); }, 120); },
    plant: function () { blip(320, 0.12, 'sine', 0.3, 520); setTimeout(function () { blip(660, 0.1, 'sine', 0.2); }, 90); },
    harvest: function () { hiss(0.25, 5000, 1.5, 0.2); setTimeout(function () { blip(880, 0.12, 'triangle', 0.25); }, 150); },
    coin: function () { blip(1320, 0.08, 'square', 0.08); setTimeout(function () { blip(1760, 0.14, 'square', 0.07); }, 70); },
    inspect: function () { blip(900, 0.2, 'sine', 0.15, 1200); },
    clear: function () { hiss(0.4, 700, 0.7, 0.3); },
    week: function () { [523, 659, 784].forEach(function (f, i) { setTimeout(function () { blip(f, 0.35, 'triangle', 0.14); }, i * 110); }); }
  };
  /* the game already plays its own short sounds for plant/water/harvest (its Sound button); ours adds only the
     farm ambience and the end-of-week chime, so nothing plays twice */
  function sfx(k) { if (k !== 'week') return; try { if (SFX[k]) SFX[k](); } catch (e) {} }

  function farmMonth(s) { var f = s && s.time && s.time.forecast && s.time.forecast[0]; var m = f && /^\d{4}-(\d\d)/.exec(f.date || ''); return m ? +m[1] : new Date().getMonth() + 1; }
  function startAmbience() {
    if (!ctx() || amb) return; if (AC.state === 'suspended') AC.resume();
    amb = { timers: [] };
    var wind = AC.createBufferSource(), lp = AC.createBiquadFilter(), wg = AC.createGain(), lfo = AC.createOscillator(), lg = AC.createGain();
    wind.buffer = noiseBuf(6, true); wind.loop = true; lp.type = 'lowpass'; lp.frequency.value = 500; wg.gain.value = 0.18;
    lfo.frequency.value = 0.07; lg.gain.value = 0.1; lfo.connect(lg); lg.connect(wg.gain);
    wind.connect(lp); lp.connect(wg); wg.connect(master); wind.start(); lfo.start();
    amb.nodes = [wind, lfo]; amb.windGain = wg;
    var bee = AC.createOscillator(), bf = AC.createBiquadFilter(), bg = AC.createGain(), trem = AC.createOscillator(), tg = AC.createGain();
    bee.type = 'sawtooth'; bee.frequency.value = 210; bf.type = 'lowpass'; bf.frequency.value = 600; bg.gain.value = 0;
    trem.frequency.value = 7; tg.gain.value = 0.012; trem.connect(tg); tg.connect(bg.gain);
    bee.connect(bf); bf.connect(bg); bg.connect(master); bee.start(); trem.start(); amb.nodes.push(bee, trem); amb.beeGain = bg;
    function chirp() {
      if (!amb) return; var s = st(), se = (s && gameSeason(s.season).name) || 'Spring', h = new Date().getHours();
      var night = h >= 20 || h < 6, warm = se === 'Summer' || se === 'Fall';
      amb.windGain.gain.setTargetAtTime(se === 'Winter' ? 0.3 : 0.16, AC.currentTime, 2);
      amb.beeGain.gain.setTargetAtTime(!night && se === 'Summer' ? 0.02 : 0, AC.currentTime, 2);
      if (night && warm) { for (var i = 0; i < 3; i++) (function (k) { setTimeout(function () { blip(4400, 0.04, 'sine', 0.05); }, k * 70); })(i); }
      else if (!night && se !== 'Winter' && Math.random() < 0.6) { var f = 2400 + Math.random() * 1400; blip(f, 0.12, 'sine', 0.06, f * 1.35); setTimeout(function () { blip(f * 1.1, 0.1, 'sine', 0.05, f * 0.9); }, 160); }
      amb.timers.push(setTimeout(chirp, night ? 900 + Math.random() * 700 : 2500 + Math.random() * 4000));
    }
    chirp();
  }
  function stopAmbience() { if (!amb) return; amb.timers.forEach(clearTimeout); amb.nodes.forEach(function (n) { try { n.stop(); } catch (e) {} }); amb = null; }
  document.addEventListener('visibilitychange', function () { if (!AC) return; if (document.hidden) AC.suspend(); else if (soundOn) AC.resume(); });

  /* ================= effects ================= */
  var layer = null;
  function fxLayer() { if (!layer || !layer.isConnected) { layer = document.createElement('div'); layer.className = 'gjx-layer'; layer.setAttribute('aria-hidden', 'true'); document.body.appendChild(layer); } return layer; }
  function burst(rect, cls, html, ms) {
    if (!rect || rect.width < 4) return;
    var el = document.createElement('div'); el.className = 'gjx ' + cls; el.innerHTML = html || '';
    el.style.left = (rect.left + rect.width / 2) + 'px'; el.style.top = (rect.top + rect.height / 2) + 'px';
    fxLayer().appendChild(el); setTimeout(function () { el.remove(); }, ms || 1400);
  }
  function plotEl(i) { var r = root(); return r && r.querySelector('#lfg-view-field [data-plot="' + i + '"]'); }
  function flash(el, cls, ms) { if (!el) return; el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms || 1300); }
  var FX = {
    water: function (el) { var r = el.getBoundingClientRect(); flash(el, 'gjx-wet', 1600); if (reduced()) return burst(r, 'gjx-tag', '💧 Watered', 1200);
      var h = ''; for (var i = 0; i < 8; i++) h += '<i style="--a:' + (i * 45 + Math.random() * 20) + 'deg;--d:' + (26 + Math.random() * 22) + 'px"></i>';
      burst(r, 'gjx-splash', h + '<b></b>', 1100); burst(r, 'gjx-tag', '💧 Watered', 1200); },
    plant: function (el) { burst(el.getBoundingClientRect(), 'gjx-pop', '🌱', 1100); burst(el.getBoundingClientRect(), 'gjx-tag', 'Planted!', 1200); },
    harvest: function (el, extra) { var r = el.getBoundingClientRect(); burst(r, 'gjx-bundle', '💐', 1300); burst(r, 'gjx-tag', 'Harvested' + (extra ? ' · ' + extra : ''), 1500); },
    inspect: function (el, extra) { var r = el.getBoundingClientRect(); burst(r, 'gjx-ping', '', 900); burst(r, 'gjx-tag', '🔍 ' + (extra || 'Checked'), 1400); },
    clear: function (el) { burst(el.getBoundingClientRect(), 'gjx-puff', '💨', 900); },
    heal: function (el, extra) { burst(el.getBoundingClientRect(), 'gjx-tag gjx-tag--good', '✨ ' + extra, 1400); }
  };
  function coinTile() {
    var r = root(); if (!r) return null;
    var tiles = r.querySelectorAll('.lfg-farm-pulse button, .lfg-farm-pulse [class*="tile"], .lfg-farm-pulse > * > *');
    for (var i = 0; i < tiles.length; i++) if (/coins/i.test(tiles[i].textContent || '') && tiles[i].offsetWidth < 400) return tiles[i];
    return null;
  }
  function coinsFloat(delta, near) {
    if (!delta) return;
    var tile = coinTile(), r = (near && near.getBoundingClientRect()) || (tile && tile.getBoundingClientRect());
    if (!r) return;
    burst(r, 'gjx-coins' + (delta < 0 ? ' gjx-coins--out' : ''), (delta > 0 ? '+' : '') + money(delta) + ' 🪙', 1600);
    if (delta > 0) sfx('coin');
  }

  /* watch field actions: compare the plot before and after */
  var pending = null;
  function beltTool() {
    var r = root(), on = r && r.querySelector('#lfg-view-field .gllf-belt__tool.is-on, #lfg-view-field [data-belt-tool][aria-pressed="true"]');
    return (on && on.getAttribute('data-belt-tool')) || ((st() || {}).tool) || '';
  }
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('#lfg-view-field [data-plot]'); if (!p) return;
    var s = st(); if (!s) return; var i = +p.getAttribute('data-plot');
    pending = { i: i, el: p, tool: beltTool(), plant: clone((s.plants || [])[i]), coins: +s.coins || 0, rec: clone(s.records) || {}, t: Date.now() };
    setTimeout(checkAction, 350); setTimeout(checkAction, 1000);
  }, true);
  function checkAction() {
    var a = pending, s = st(); if (!a || !s || a.done) return;
    var now = (s.plants || [])[a.i], was = a.plant, el = plotEl(a.i) || a.el, rec = s.records || {};
    var dc = (+s.coins || 0) - a.coins, hit = null;
    if (!was && now) hit = ['plant'];
    else if (was && !now) hit = (+rec.harvested || 0) > (+a.rec.harvested || 0) ? ['harvest', dc > 0 ? '+' + money(dc) + ' coins' : ''] : ['clear'];
    else if (was && now) {
      if (+now.moist > +was.moist + 3) hit = ['water'];
      else if ((+rec.harvested || 0) > (+a.rec.harvested || 0)) hit = ['harvest', dc > 0 ? '+' + money(dc) + ' coins' : ''];
      else if (+now.health > +was.health + 2) hit = ['heal', 'Health ' + Math.round(was.health) + ' → ' + Math.round(now.health)];
      else if (a.tool === 'inspect' && JSON.stringify(now) !== JSON.stringify(was)) hit = ['inspect', 'Health ' + Math.round(now.health) + '% · moisture ' + Math.round(now.moist) + '%'];
    }
    if (!hit) return;
    a.done = true;
    if (FX[hit[0]] && el) FX[hit[0]](el, hit[1]);
    sfx(hit[0] === 'heal' ? 'inspect' : hit[0]);
    if (dc > 0) sfx('coin');   /* the game already floats the coin change by the Coins tile */
  }

  /* bees on blooming plots, mist in the early morning */
  function decorate() {
    var r = root(), s = st(); if (!r || !s) return;
    (s.plants || []).forEach(function (p, i) {
      var el = plotEl(i); if (!el) return;
      var bloom = !!(p && p.phenology && (+p.phenology.bloomStage || 0) > 0 && !p.dormant);
      if (el.classList.contains('gjx-bloom') !== bloom) el.classList.toggle('gjx-bloom', bloom);
    });
    var board = r.querySelector('#lfg-field'), h = new Date().getHours();
    if (board) { var mist = h >= 5 && h < 9; if (board.classList.contains('gjx-mist') !== mist) board.classList.toggle('gjx-mist', mist); }
  }

  /* ================= weekly report ================= */
  var SEASON = [
    { name: 'Winter', months: [12, 1, 2], art: 'midwest-freeze-thaw', line: 'Your lavender sleeps. Dry crowns and snow cover matter more than anything you do.' },
    { name: 'Spring', months: [3, 4, 5], art: 'lavender-young-rootball', line: 'The ground wakes up. Planting season opens after your last frost.' },
    { name: 'Summer', months: [6, 7, 8], art: 'lavender-festival', line: 'Bloom time. Harvest when a third to half of the buds are open.' },
    { name: 'Fall', months: [9, 10, 11], art: 'harvest-crate-filled', line: 'Time to tidy, prune lightly and get the field ready for winter.' }
  ];
  function gameSeason(i) { var k = ['Spring', 'Summer', 'Fall', 'Winter'][((+i || 0) % 4 + 4) % 4]; return SEASON.filter(function (x) { return x.name === k; })[0]; }
  function seasonOf(m) { for (var i = 0; i < SEASON.length; i++) if (SEASON[i].months.indexOf(m) >= 0) return SEASON[i]; return SEASON[0]; }
  function wkDate(s) { var f = s && s.time && s.time.forecast && s.time.forecast[0]; return f && f.date ? f.date : ''; }
  function nice(d) { var m = /^(\d{4})-(\d\d)-(\d\d)/.exec(d || ''); if (!m) return ''; return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][+m[2] - 1] + ' ' + (+m[3]); }

  var snap = null;
  function snapshot() {
    var s = st(); if (!s) return null;
    return { week: s.week, season: s.season, date: wkDate(s), coins: +s.coins || 0, xp: +s.xp || 0, level: s.level, plants: clone(s.plants) || [], rec: clone(s.records) || {}, fc: clone(s.time && s.time.forecast) || [], unread: unread() };
  }
  function unread() { var r = root(), t = r && r.querySelector('.lfg-farm-pulse'); var m = t && /(\d+)\s*unread/i.exec(t.textContent || ''); return m ? +m[1] : 0; }
  function watchWeek() {
    snap = snapshot(); if (!snap) return;
    var w0 = snap.week, n = 0;
    (function wait() {
      var s = st(); if (!s || !snap) return;
      if (s.week !== w0) { setTimeout(function () { report(snap); }, 900); return; }
      if (++n < 60) setTimeout(wait, 250);
    })();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-action="advance"]'); if (!b) return;
    if (!e.isTrusted && !(window.__gllfWantReport && Date.now() - window.__gllfWantReport < 3000)) return;
    watchWeek();
  }, true);

  var HUCK = {
    cold: ['Brr! I kept the crowns company all week. Lavender handles the cold — it’s wet feet that hurt it.', 'Snow on the rows is like a blanket. I checked every plot twice.'],
    hot: ['Hot one! I found the only shade on the farm. The lavender loved it, though.', 'Dry heat is lavender weather. Water only the young plants.'],
    empty: ['The field is all ready for you. I only dug one hole, I promise.', 'Nothing planted yet, so I practiced guarding the empty rows. Ready when you are!'],
    frost: ['Frosty mornings this week! I left paw prints in the rows. Young plants like a frost-cloth blanket.', 'Cold nights, sunny days. The lavender is waiting for warmer weather, same as me.'],
    worry: ['Some of our plants had a rough week. Let’s take a closer look at them together.', 'I sniffed around the field — a few plants aren’t happy. Worth an inspection.'],
    wet: ['So much rain! I checked the low end of the field — watch for puddles near the roots.'],
    bloom: ['The whole field smells amazing. The bees and I have been busy!', 'Purple everywhere! Time to get the shears ready.'],
    calm: ['Quiet week. I walked the rows with you — everything looks steady.', 'Good week for chores. I found three sticks and zero problems.', 'I herded the chickens away from the new plants. You’re welcome.']
  };
  function pick(a, k) { return a[(k || 0) % a.length]; }

  function report(b) {
    var s = st(), r = root(); if (!s || !r || ls('gllfWeekReportOff') === '1') return;
    if (document.querySelector('.gjx-report')) return;
    var fc = b.fc || [], lows = fc.map(function (d) { return +d.low; }).filter(isFinite), highs = fc.map(function (d) { return +d.high; }).filter(isFinite);
    var lo = lows.length ? Math.min.apply(null, lows) : null, hi = highs.length ? Math.max.apply(null, highs) : null;
    var rain = fc.reduce(function (a, d) { return a + (+d.precip || 0); }, 0), snow = fc.reduce(function (a, d) { return a + (+d.snowfall || 0); }, 0);
    /* seasons follow the game's own calendar (the same Spring/Summer/Fall/Winter shown on the field) */
    var sNow = gameSeason(s.season), sWas = gameSeason(b.season);
    var turned = b.season != null && sWas.name !== sNow.name;
    var yr = s.year;

    /* plants */
    var grew = [], hurt = [], lost = 0, bloomed = [], total = 0;
    (s.plants || []).forEach(function (p, i) {
      var q = b.plants[i]; if (p) total++;
      if (q && !p) lost++;
      if (!p || !q) return;
      if (+p.stage > +q.stage) grew.push(i + 1);
      if (+p.health < +q.health - 8) hurt.push([i + 1, Math.round(q.health), Math.round(p.health)]);
      var pb = +(p.phenology || {}).bloomStage || 0, qb = +(q.phenology || {}).bloomStage || 0;
      if (pb > 0 && qb === 0) bloomed.push(i + 1);
    });
    var rec = s.records || {}, br = b.rec || {};
    var dc = (+s.coins || 0) - b.coins, rev = (+rec.revenue || 0) - (+br.revenue || 0), exp = (+rec.expenses || 0) - (+br.expenses || 0);
    var msgs = unread() - (b.unread || 0);

    var mood = (!total && !lost) ? 'empty' : bloomed.length ? 'bloom' : (lo != null && lo <= 20) ? 'cold' : hurt.length ? 'worry' : (lo != null && lo <= 32) ? 'frost' : (hi != null && hi >= 90) ? 'hot' : rain >= 1.5 ? 'wet' : 'calm';
    var huck = pick(HUCK[mood], s.week);

    var lines = [];
    if (fc.length) lines.push(['🌦️', 'Weather in ' + place(s), 'Lows ' + Math.round(lo) + '°F, highs ' + Math.round(hi) + '°F' + (rain >= 0.05 ? ', ' + rain.toFixed(1) + ' in of rain' : ', dry') + (snow >= 0.5 ? ', ' + snow.toFixed(1) + ' in of snow' : '') + '.']);
    var fl = [];
    if (!total && !lost) fl.push('Nothing planted yet.');
    if (grew.length) fl.push('Plot ' + grew.join(', ') + ' grew to the next stage.');
    if (bloomed.length) fl.push('First flowers on plot ' + bloomed.join(', ') + '!');
    if (hurt.length) fl.push(hurt.slice(0, 3).map(function (h) { return 'Plot ' + h[0] + ' health ' + h[1] + '→' + h[2]; }).join('; ') + (lo != null && lo <= 20 ? ' (hard freeze).' : '.'));
    if (lost) fl.push(lost + ' plant' + (lost > 1 ? 's' : '') + ' lost.');
    if (!fl.length && total) fl.push('All ' + total + ' plants held steady.');
    lines.push(['🌱', 'Your field', fl.join(' ')]);
    if (dc || rev || exp) lines.push(['🪙', 'Money', (rev ? 'Earned ' + money(rev) + '. ' : '') + (exp ? 'Spent ' + money(exp) + '. ' : '') + 'Net ' + (dc >= 0 ? '+' : '') + money(dc) + ' coins.']);

    var surprise = bloomed.length ? ['🌸', 'Bumper surprise', 'Your first blooms opened this week. Bees will find them within days.']
      : (lo != null && lo <= 10) ? ['🥶', 'Surprise cold snap', 'It hit ' + Math.round(lo) + '°F. Established lavender survives this; young plants are the ones at risk.']
      : msgs > 0 ? ['📱', 'Farm phone', msgs + ' new message' + (msgs > 1 ? 's' : '') + ' — someone might want to buy lavender.']
      : hurt.length ? ['⚠️', 'Heads up', 'Some plants lost health. Inspect them before it spreads.'] : null;
    if (surprise) lines.push(surprise);

    var step = window.GLLFLoop && window.GLLFLoop.nextStep();
    var el = document.createElement('div'); el.className = 'gjx-report'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'gjx-report-t');
    el.innerHTML = '<div class="gjx-report__card">' +
      '<button type="button" class="gjx-report__x" data-gjx-close aria-label="Close">✕</button>' +
      (turned ? '<div class="gjx-season"><img src="' + art(sNow.art) + '" alt="" onerror="this.remove()"><div><small>A new season</small><h2 id="gjx-report-t">' + sNow.name + ', Year ' + esc(yr) + '</h2><p>' + esc(sNow.line) + '</p></div></div>'
        : '<header class="gjx-report__head"><small>Weekly farm report</small><h2 id="gjx-report-t">Week of ' + esc(nice(wkDate(s)) || ('week ' + s.week)) + ', Year ' + esc(yr) + '</h2></header>') +
      '<div class="gjx-huck"><img src="' + art('huckleberry-playful') + '" alt="" onerror="this.remove()"><p><b>Huckleberry:</b> ' + esc(huck) + '</p></div>' +
      '<ul class="gjx-report__list">' + lines.map(function (x) { return '<li><span aria-hidden="true">' + x[0] + '</span><div><b>' + esc(x[1]) + '</b><p>' + esc(x[2]) + '</p></div></li>'; }).join('') + '</ul>' +
      (step ? '<div class="gjx-decide"><small>Your decision for next week</small><p>' + esc(step.icon + ' ' + step.text) + '</p>' + (step.go !== 'advance' ? '<button type="button" class="gjx-btn gjx-btn--soft" data-gjx-step>' + esc(step.btn) + ' →</button>' : '') + '</div>' : '') +
      '<div class="gjx-report__row"><button type="button" class="gjx-btn" data-gjx-next>Next week →</button><button type="button" class="gjx-btn gjx-btn--soft" data-gjx-close>Back to the farm</button></div>' +
      '<label class="gjx-report__off"><input type="checkbox" data-gjx-off> Don’t show this after every week</label>' +
      '</div>';
    document.body.appendChild(el);
    sfx('week');
    var last = document.activeElement;
    function close() { el.remove(); document.removeEventListener('keydown', key, true); try { last && last.focus && last.focus(); } catch (e) {} }
    function key(e) { if (e.key === 'Escape') { e.preventDefault(); close(); } }
    document.addEventListener('keydown', key, true);
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.closest('[data-gjx-close]')) return close();
      if (e.target.closest('[data-gjx-next]')) { close(); if (window.GLLFLoop) window.GLLFLoop.act({ go: 'advance' }); return; }
      if (e.target.closest('[data-gjx-step]')) { close(); if (window.GLLFLoop && step) window.GLLFLoop.act(step); }
    });
    el.querySelector('[data-gjx-off]').addEventListener('change', function (e) { ls('gllfWeekReportOff', e.target.checked ? '1' : '0'); });
    setTimeout(function () { var n = el.querySelector('[data-gjx-next]'); if (n) n.focus(); }, 40);
  }

  /* ================= wiring ================= */
  window.GLLFJuice = {
    soundOn: function () { return soundOn; },
    toggleSound: function () { soundOn = !soundOn; ls('gllfSoundV1', soundOn ? '1' : '0'); if (soundOn) startAmbience(); else stopAmbience(); },
    report: function () { report(snapshot()); },
    watchWeek: watchWeek,
    fx: function (k, i) { var el = plotEl(i); if (el && FX[k]) FX[k](el); }
  };
  if (soundOn) {
    var kick = function () { document.removeEventListener('pointerdown', kick, true); startAmbience(); };
    document.addEventListener('pointerdown', kick, true);   /* browsers only allow sound after a tap */
  }
  var lastCoins = null;
  setInterval(function () {
    var s = st(); if (!s) return;
    try { decorate(); } catch (e) {}
    var c = +s.coins || 0;
    if (lastCoins != null && c > lastCoins && !(pending && Date.now() - pending.t < 1500)) sfx('coin');
    lastCoins = c;
  }, 1500);
})();
